<template>
  <div id="load">
    Loading...
  </div>
</template>
<script>
export default {
  name: 'load',
  components: {
  },
  mounted: function() {
    //IEの場合、社内サイトに遷移、それ以外の場合、HOMEに遷移 
    var userAgent = window.navigator.userAgent.toLowerCase();
    if( userAgent.match(/(msie|MSIE)/) || userAgent.match(/(T|t)rident/) ) {
      window.location.href = 'https://stnck.suzuki.co.jp/confirm/mc.aspx?Op=' + this.$route.query.tc;
    } else {
      this.$router.replace({ path: 'Home', query: { tc: this.$route.query.tc} });
    }
  }
}
</script>